/**
 * Small chip indicating ephemeris data source (NASA, ExoFOP, ExoClock).
 */
import React from 'react';
import { Chip, Tooltip } from '@mui/material';

const sourceConfig = {
  'NASA': { label: 'NASA', color: 'primary' },
  'ExoFOP-TESS': { label: 'EF', color: 'info' },
  'ExoClock': { label: 'EC', color: 'success' },
};

const EphemerisSourceChip = ({ source }) => {
  if (!source || source === 'NASA') return null;

  const config = sourceConfig[source] || {
    label: source.substring(0, 2),
    color: 'default'
  };

  return (
    <Tooltip title={`Ephemeris from ${source}`}>
      <Chip
        label={config.label}
        size="small"
        color={config.color}
        sx={{ ml: 0.5, height: 18, fontSize: '0.7rem' }}
      />
    </Tooltip>
  );
};

export default EphemerisSourceChip;
